export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-semibold mb-4 whitespace-nowrap">
              Why Pandabuy Sheet
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Better Than
              <br />
              Searching
              <br />
              <span className="italic text-primary-500">Manually</span>
            </h2>
          </div>
          <div className="lg:w-2/3 flex items-end">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              Finding quality products through traditional browsing is slow, inconsistent, and overwhelming. Our pandabuy sheet system organizes the best finds into structured, searchable, and ranked tables — saving you hours while ensuring you never miss a great deal.
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 rounded-3xl overflow-hidden">
          <div className="lg:w-5/12 h-64 md:h-80 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20displaying%20organized%20product%20spreadsheet%20data%20on%20screen%20warm%20cream%20desk%20surface%20soft%20morning%20light%20from%20window%20editorial%20photography%20minimalist%20aesthetic%20neutral%20calm%20tones&width=700&height=500&seq=about-left-v2&orientation=landscape"
              alt="Organized pandabuy sheet product system"
              className="w-full h-full object-cover"
              title="Pandabuy Sheet organized system"
            />
          </div>
          <div className="lg:w-7/12 h-64 md:h-80 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Beautifully%20curated%20flatlay%20of%20fashion%20accessories%20and%20clothing%20items%20including%20folded%20fabric%20sunglasses%20watch%20and%20small%20leather%20goods%20on%20warm%20cream%20surface%20soft%20diffused%20daylight%20editorial%20product%20photography%20clean%20composition&width=900&height=500&seq=about-right-v2&orientation=landscape"
              alt="Curated pandabuy sheet products"
              className="w-full h-full object-cover"
              title="Pandabuy Sheet curated items"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-10 md:mt-12">
          {[
            { icon: 'ri-database-2-line', label: 'Verified Products', desc: 'Quality-checked items' },
            { icon: 'ri-bar-chart-2-line', label: 'Data-Driven', desc: 'Ranked comparison tables' },
            { icon: 'ri-flashlight-line', label: 'Fast Browsing', desc: 'Instant category access' },
            { icon: 'ri-links-line', label: 'Direct Links', desc: 'One-click to source' },
          ].map((item) => (
            <div key={item.label} className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-2xl bg-accent-100 flex items-center justify-center">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-accent-600 text-xl`}></i>
                </span>
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {item.label}
              </h4>
              <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}